export default {
  install(Vue) {
    // 全局的Vue mixin方法，好处是不用每个组件自己去处理注入方法
    Vue.mixin({
      data() {
        return {
          //  用来保存国际化的 key
          i18nKey: ''
        };
      },
      computed: {
        //  用 computed 读取出文案，达到切换语言自动更新
        domTitle() {
          if (this.$t && this.i18nKey) {
            return this.$t(this.i18nKey);
          }
          return '';
        }
      },
      watch: {
        //  更新触发设置
        domTitle(val) {
          this.updateDocumentTitle(val);
        }
      },
      created() {
        // 获取组件下定义的 documentTitle 自定义属性
        const titleType = typeof this.$options.documentTitle
        if (['string', 'function'].indexOf(titleType) !== -1) {
          this.updateDocumentTitle(titleType === 'function' ?
          this.$options.documentTitle.call(this) : this.$options.documentTitle);
        } else if (titleType === 'object' && this.$options.documentTitle.i18n) {
          this.i18nKey = this.$options.documentTitle.i18n;
        }
      },
      methods: {
        updateDocumentTitle(___title) {
          const ___titleList = ___title.split('');
          const __title = ___titleList.map((e, i) => (i === 0 || !/^[a-zA-Z0-9\u4e00-\u9fa5]$/.test(___titleList[i - 1])) && e.toLocaleUpperCase() || e).join('');
          document.title = __title;
          if (navigator.userAgent.toLowerCase().indexOf('wownow') !== -1) {
            this.$root.currentDocumentTitle = __title;
            window?.WOWNOW?.setNavigationBarTitle?.({
              title: __title
            });
          }
        }
      }
    })
  }
}
